import { bettingRecommendations } from '@/mocks/homeData';

export default function BettingSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              竞猜推荐
              <span className="inline-flex items-center ml-3 px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-bold">
                <i className="ri-fire-line mr-1"></i>热门
              </span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">专业分析师团队，精准赛事预测</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {bettingRecommendations.map((bet) => (
              <div
                key={bet.id}
                className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full">{bet.league}</span>
                  <span className="text-xs text-foreground-400">{bet.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-4 group-hover:text-accent-600 transition-colors">{bet.match}</h3>

                <div className="flex items-center gap-2 mb-4">
                  {bet.odds.home && (
                    <div className="flex-1 text-center py-2 bg-background-100 rounded-lg">
                      <div className="text-xs text-foreground-500 mb-0.5">主胜</div>
                      <div className="text-base font-heading font-bold text-foreground-900">{bet.odds.home}</div>
                    </div>
                  )}
                  {bet.odds.draw && (
                    <div className="flex-1 text-center py-2 bg-background-100 rounded-lg">
                      <div className="text-xs text-foreground-500 mb-0.5">平</div>
                      <div className="text-base font-heading font-bold text-foreground-900">{bet.odds.draw}</div>
                    </div>
                  )}
                  {bet.odds.away && (
                    <div className="flex-1 text-center py-2 bg-background-100 rounded-lg">
                      <div className="text-xs text-foreground-500 mb-0.5">客胜</div>
                      <div className="text-base font-heading font-bold text-foreground-900">{bet.odds.away}</div>
                    </div>
                  )}
                  {bet.odds.spread !== undefined && (
                    <div className="flex-1 text-center py-2 bg-background-100 rounded-lg">
                      <div className="text-xs text-foreground-500 mb-0.5">让分</div>
                      <div className="text-base font-heading font-bold text-foreground-900">{bet.odds.spread}</div>
                    </div>
                  )}
                </div>

                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
                    推荐：{bet.recommendation}
                  </span>
                  <div className="flex-1 h-1.5 bg-background-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-accent-500 rounded-full transition-all duration-500"
                      style={{ width: `${bet.confidence}%` }}
                    ></div>
                  </div>
                  <span className="text-xs font-bold text-accent-600">{bet.confidence}%</span>
                </div>
                <p className="text-xs text-foreground-500">{bet.analysis}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}